var PrefillSources;
(function(PrefillSources) {
    PrefillSources["Cart"] = 'cart';
    PrefillSources["UserData"] = 'userData';
    PrefillSources["AddressBook"] = 'addressBook';
    PrefillSources["AutoComplete"] = 'autoComplete';
})(PrefillSources || (PrefillSources = {}));

export { PrefillSources };
//# sourceMappingURL=types.js.map
